// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-container {
    text-align: center;
    min-height: 90vh;
    margin: auto;
    padding: 2rem;
    padding-top: 10rem;
}

.not-found-header {
    margin-bottom: 2rem;
}

.not-found-header h1 {
    font-size: 2.5rem;
    color: #333;
}

.not-found-header p {
    font-size: 1.2rem;
    color: #666;
}`, "",{"version":3,"sources":["webpack://./src/pages/not-found/NotFound.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".not-found-container {\n    text-align: center;\n    min-height: 90vh;\n    margin: auto;\n    padding: 2rem;\n    padding-top: 10rem;\n}\n\n.not-found-header {\n    margin-bottom: 2rem;\n}\n\n.not-found-header h1 {\n    font-size: 2.5rem;\n    color: #333;\n}\n\n.not-found-header p {\n    font-size: 1.2rem;\n    color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
